module.exports = __webpack_public_path__ + "img/shareLink.53c17c5.png";